// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "../../styles/Theme.bs.js";
import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function Blockquote$Blockquote(props) {
  let __className = props.className;
  let cite = props.cite;
  let className = __className !== undefined ? __className : "";
  let quoteStyles = Emotion.Css.css({
    fontFamily: Theme.Theme.Typography.fontFamily.serif,
    fontSize: "1.375rem",
    fontWeight: "400",
    fontStyle: "italic",
    lineHeight: "1.6",
    color: Emotion.Utils.Color.textPrimary,
    borderLeft: `3px solid ` + Emotion.Utils.Color.primary,
    paddingLeft: "1.5rem",
    margin: "2rem 0"
  });
  let citeStyles = Emotion.Css.css({
    display: "block",
    marginTop: "0.75rem",
    fontFamily: Theme.Theme.Typography.fontFamily.sans,
    fontSize: "0.8125rem",
    fontStyle: "normal",
    fontWeight: "400",
    letterSpacing: "0.05em",
    color: Emotion.Utils.Color.textSecondary
  });
  let quoteClassName = Emotion.Css.cx([
    quoteStyles,
    className
  ]);
  return JsxRuntime.jsxs("blockquote", {
    children: [
      props.children,
      cite !== undefined ? JsxRuntime.jsx("cite", {
          children: `\u2014 ` + cite,
          className: citeStyles
        }) : null
    ],
    className: quoteClassName
  });
}

let Blockquote = {
  make: Blockquote$Blockquote
};

export {
  Blockquote,
}
/* Theme Not a pure module */
